import { c as _c } from "react-compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { numberFormat } from '@nike/i18n-core';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import { OriginalPrice, FormattedPriceContainer, VisuallyHidden, Break, JapanPriceAddendum, PriceContainer } from './styles';
import getWebShellClientLocale from "../../state/redux-replacement/get-webshellclient-locale";
import DiscountAddendum from "../discount-addendum/DiscountAddendum";
import LowestPriceAddendum from "../lowest-price-addendum/LowestPriceAddendum";
var PriceLabel = function PriceLabel(t0) {
  var $ = _c(2);
  var children = t0.children;
  var t1;
  if ($[0] !== children) {
    t1 = children ? /*#__PURE__*/React.createElement(VisuallyHidden, null, children) : null;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
PriceLabel.propTypes = {
  children: PropTypes.string
};
var Price = function Price(t0) {
  var _getWebShellClientLoc;
  var $ = _c(33);
  var listPrice = t0.listPrice,
    discountedPrice = t0.discountedPrice,
    currency = t0.currency,
    className = t0.className;
  var _ref = (_getWebShellClientLoc = getWebShellClientLocale()) !== null && _getWebShellClientLoc !== void 0 ? _getWebShellClientLoc : {},
    country = _ref.country,
    localeForCurrency = _ref.hreflang;
  var t1;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = {
      stringKey: "product.originalPrice.label",
      primaryValue: "Original price",
      description: "Product's original price label"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  var originalPriceLabel = useI18nString(t1);
  var t2;
  if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
    t2 = {
      stringKey: "product.salePrice.label",
      primaryValue: "Sale price",
      description: "Product's sale price label"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  var salePriceLabel = useI18nString(t2);
  var t3;
  if ($[2] === Symbol["for"]("react.memo_cache_sentinel")) {
    t3 = {
      stringKey: "JP.podium_tax_included",
      primaryValue: "(Tax Incl.)",
      description: "A note near the price of an item to denote that tax is included."
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  var taxesIncludedLabel = useI18nString(t3);
  if (typeof window === "undefined") {
    return null;
  }
  var isJapan = country === "jp";
  var isPoland = country === "pl";
  var formattingOptions = {
    currency: currency,
    encourageWholeNumbers: true
  };
  var t4 = discountedPrice != null ? originalPriceLabel : undefined;
  var t5;
  if ($[3] !== t4) {
    t5 = /*#__PURE__*/React.createElement(PriceLabel, null, t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  var formattedListPrice = /*#__PURE__*/React.createElement(FormattedPriceContainer, {
    className: "formatted-price"
  }, t5, numberFormat(localeForCurrency, listPrice, formattingOptions));
  var priceContent;
  if (discountedPrice == null && isJapan) {
    var _t;
    if ($[5] === Symbol["for"]("react.memo_cache_sentinel")) {
      _t = /*#__PURE__*/React.createElement("br", null);
      $[5] = _t;
    } else {
      _t = $[5];
    }
    var _t2;
    if ($[6] !== taxesIncludedLabel) {
      _t2 = /*#__PURE__*/React.createElement(JapanPriceAddendum, null, taxesIncludedLabel);
      $[6] = taxesIncludedLabel;
      $[7] = _t2;
    } else {
      _t2 = $[7];
    }
    priceContent = /*#__PURE__*/React.createElement("span", null, formattedListPrice, _t, _t2);
  } else {
    if (discountedPrice == null) {
      priceContent = formattedListPrice;
    } else {
      var formattedDiscountPrice = numberFormat(localeForCurrency, discountedPrice, formattingOptions);
      if (isPoland) {
        var _t3;
        if ($[8] !== salePriceLabel) {
          _t3 = /*#__PURE__*/React.createElement(PriceLabel, null, salePriceLabel);
          $[8] = salePriceLabel;
          $[9] = _t3;
        } else {
          _t3 = $[9];
        }
        var _t4 = "".concat(formattedDiscountPrice);
        var t8;
        if ($[10] !== _t3 || $[11] !== _t4) {
          t8 = /*#__PURE__*/React.createElement("span", {
            key: "sp-sp",
            className: "sale-price"
          }, _t3, _t4);
          $[10] = _t3;
          $[11] = _t4;
          $[12] = t8;
        } else {
          t8 = $[12];
        }
        var t10;
        var t9;
        if ($[13] === Symbol["for"]("react.memo_cache_sentinel")) {
          t9 = /*#__PURE__*/React.createElement(Break, {
            key: "break"
          });
          t10 = /*#__PURE__*/React.createElement(LowestPriceAddendum, {
            key: "lowest-price-addendum"
          });
          $[13] = t10;
          $[14] = t9;
        } else {
          t10 = $[13];
          t9 = $[14];
        }
        priceContent = [/*#__PURE__*/React.createElement("s", {
          className: "original-price pl",
          key: "sp-op",
          "aria-label": originalPriceLabel
        }, formattedListPrice), t8, t9, t10];
      } else {
        if (isJapan) {
          var _t5;
          if ($[15] !== salePriceLabel) {
            _t5 = /*#__PURE__*/React.createElement(PriceLabel, null, salePriceLabel);
            $[15] = salePriceLabel;
            $[16] = _t5;
          } else {
            _t5 = $[16];
          }
          var _t6;
          if ($[17] === Symbol["for"]("react.memo_cache_sentinel")) {
            _t6 = /*#__PURE__*/React.createElement("br", null);
            $[17] = _t6;
          } else {
            _t6 = $[17];
          }
          var _t7;
          if ($[18] === Symbol["for"]("react.memo_cache_sentinel")) {
            _t7 = /*#__PURE__*/React.createElement(DiscountAddendum, null);
            $[18] = _t7;
          } else {
            _t7 = $[18];
          }
          var _t8;
          if ($[19] !== taxesIncludedLabel) {
            _t8 = /*#__PURE__*/React.createElement(JapanPriceAddendum, null, taxesIncludedLabel, " ", _t7);
            $[19] = taxesIncludedLabel;
            $[20] = _t8;
          } else {
            _t8 = $[20];
          }
          var _t9;
          if ($[21] !== formattedDiscountPrice || $[22] !== _t5 || $[23] !== _t8) {
            _t9 = /*#__PURE__*/React.createElement("span", {
              key: "sp-sp",
              className: "sale-price"
            }, _t5, formattedDiscountPrice, _t6, _t8);
            $[21] = formattedDiscountPrice;
            $[22] = _t5;
            $[23] = _t8;
            $[24] = _t9;
          } else {
            _t9 = $[24];
          }
          priceContent = _t9;
        } else {
          var _t0;
          if ($[25] !== salePriceLabel) {
            _t0 = /*#__PURE__*/React.createElement(PriceLabel, null, salePriceLabel);
            $[25] = salePriceLabel;
            $[26] = _t0;
          } else {
            _t0 = $[26];
          }
          var _t1;
          if ($[27] !== formattedDiscountPrice || $[28] !== _t0) {
            _t1 = /*#__PURE__*/React.createElement(FormattedPriceContainer, {
              key: "sp-sp",
              className: "sale-price"
            }, _t0, formattedDiscountPrice);
            $[27] = formattedDiscountPrice;
            $[28] = _t0;
            $[29] = _t1;
          } else {
            _t1 = $[29];
          }
          priceContent = [/*#__PURE__*/React.createElement(OriginalPrice, {
            className: "original-price",
            key: "sp-op"
          }, formattedListPrice), _t1];
        }
      }
    }
  }
  var t6 = "price".concat(className ? " ".concat(className) : "");
  var t7;
  if ($[30] !== priceContent || $[31] !== t6) {
    t7 = /*#__PURE__*/React.createElement(PriceContainer, {
      className: t6
    }, priceContent);
    $[30] = priceContent;
    $[31] = t6;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  return t7;
};
Price.propTypes = {
  listPrice: PropTypes.number.isRequired,
  discountedPrice: PropTypes.number,
  currency: PropTypes.string.isRequired,
  className: PropTypes.string
};
export default Price;